import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Container, FormGroup, Input, Label, Row } from 'reactstrap';
import TableGenerator from '../../../../../components/TableGenerator/TableGenerator';
// import CheckBox from '../../../../../components/CheckBox/CheckBox';
import { adjustDate, dateFormat } from '../../../../../utilities/dates';
import CheckedImage from '../../../../../assets/imgs/checked.png';
import UncheckedImage from '../../../../../assets/imgs/unchecked.png';
import * as actions from '../../../../../store/actions';
import Overlay from '../../../../../components/Overlay/overlay';
import Spinner from '../../../../../components/Spinner/Spinner';
import axios from 'axios';

class BulkSendPdfModal extends Component {
  state = {
    participants: [],
    searchedParticipants: [],
    search: '',
    isSelectAll: false,
    isLoading: false,
    error: null,
    templateId: 'parent',
    signedUrl: null
  };

  componentWillMount() {
    const initialParticipants = this.props.participants
      .filter(participant => participant.participantStatus === 'Completed')
      .sort((p, q) => p.lastName.localeCompare(q.lastName))
      .map((participant, index) => {
        participant.checked = false;
        participant.position = index;
        return participant;
      });
    this.setState({ participants: initialParticipants });
  }

  handleStatusChange = value => {
    console.log(value);
    this.setState({ status: value });
  };

  bulkDownloadReports = async (surveyParticipantIds, templateId = 'student') => {
    console.log("bulkDownloadReports: ", surveyParticipantIds);
    const filename = `${this.state.isSelectAll ? 'All' : surveyParticipantIds.length + ' Selected'} ${templateId} Reports (${this.props.survey.surveyName.replace(/[^a-z0-9 ]/gi, '_')})`;
    const data = JSON.stringify({
      "s3Keys": surveyParticipantIds.map(id => `${templateId}/report-${id}.pdf`)
    });
    const url = `${process.env.REACT_APP_API_URL}/reports/v2/student/bulk?filename=${encodeURIComponent(filename)}`;
    console.log(url)
    const response = await axios({
      url,
      method: 'POST',
      headers: {
        Authorization: this.props.idToken
      },
      data,
    })
    return response.data
  }

  handleSubmit = async () => {
    this.setState({ isLoading: true });
    const surveyParticipantIds = this.state.participants
      .filter(participant => participant.checked === true)
      .map(participant => participant.surveyParticipantId);
    try {
      const { signedUrl } = await this.bulkDownloadReports(surveyParticipantIds, this.state.templateId)
      this.setState({ isLoading: false });
      this.setState({ signedUrl })
      // window.open(signedUrl, "_blank"); // risk of triggering popup blocker
      // this.props.closeModal();
      // this.props.openToaster(`Reports have been downloaded. Please check your download folder.`);
    } catch (error) {
      this.setState({ error: error.msg });
    }
  };

  handleDownload = () => {
      this.props.closeModal();
      this.props.openToaster(`Reports have been downloaded. Please check your download folder.`);
  }

  searchForNames = e => {
    const searchedParticipants = this.state.participants.filter(
      participant =>
        participant.firstName.toLowerCase().includes(e.target.value.toLowerCase()) ||
        participant.lastName.toLowerCase().includes(e.target.value.toLowerCase()) ||
        (participant.firstName.toLowerCase() + ' ' + participant.lastName.toLowerCase()).includes(e.target.value.toLowerCase()),
    );

    this.setState({ searchedParticipants, search: e.target.value });
  };

  handleClick = index => {
    console.log(index);
    const getClickedParticipant = () => {
      if (this.state.search !== '') {
        const participants = this.state.participants.map(participant => {
          if (participant.position === this.state.searchedParticipants[index].position) {
            participant.checked = !participant.checked;
          }
          return participant;
        });
        this.setState({ participants });
      } else {
        const participants = this.state.participants.map(participant => {
          if (participant.position === index) {
            participant.checked = !participant.checked;
          }
          return participant;
        });
        this.setState({ participants, isSelectAll: false });
      }
    };
    getClickedParticipant();
  };

  generateTableData = () => {
    const result = this.state.participants.map(participant => ({
      name: `${participant.lastName}, ${participant.firstName}`,
      DOB: adjustDate(participant.birthDate).format(dateFormat),
      selected: <img className="checkbox" style={{ cursor: 'pointer' }} alt="Checkbox" src={participant.checked ? CheckedImage : UncheckedImage} />,
    }));
    if (this.state.search !== '')
      return this.state.searchedParticipants.map(participant => ({
        name: `${participant.lastName}, ${participant.firstName}`,
        DOB: adjustDate(participant.birthDate).format(dateFormat),
        selected: <img className="checkbox" alt="Checkbox" src={participant.checked ? CheckedImage : UncheckedImage} />,
      }));
    return result;
  };
  handleTemplateChange = (value) => this.setState({ templateId: value })

  handleIsSelectAll = () => {
    this.setState({
      isSelectAll: !this.state.isSelectAll,
      participants: this.state.participants.map(participant => {
        participant.checked = !this.state.isSelectAll;
        return participant;
      }),
    });
  };

  render() {
    return (
      <Overlay className="survey-status-modal-wrapper" title={'Bulk Download Reports'} isOpen={this.props.show} onToggle={this.props.closeModal}>
        <Container>
          <Row>
            <p>Use this page to bulk download parent or student reports for selected participants. You will get a compressed folder containing all the reports in PDF format.</p>
          </Row>
          <FormGroup check inline className='me-3'>
            <Label check>
              <Input name="inputSelectAll" type="checkbox" value="inputSelectAll" onChange={this.handleIsSelectAll} checked={this.state.isSelectAll} />Select All Participants
            </Label>
          </FormGroup>
          <FormGroup check inline>
            <Label check><Input name='template' type='radio' value='parent' onChange={() => this.handleTemplateChange('parent')} checked={this.state.templateId === 'parent'} /> Parent Report</Label>
          </FormGroup>
          <FormGroup check inline>
            <Label check><Input name='template' type='radio' value='student' onChange={() => this.handleTemplateChange('student')} checked={this.state.templateId === 'student'} /> Student Report</Label>
          </FormGroup>
          <input
            className="form-control"
            style={{ border: '1px solid #CACACA' }}
            type="text"
            onChange={this.searchForNames}
            value={this.state.search}
            placeholder='Search Participants'
          />
          <div className="modal-table-container">
            <TableGenerator
              config={{
                headers: ['PARTICIPANT', 'DATE OF BIRTH', ''],
                contentRows: this.generateTableData(),
                rowFunction: this.handleClick,
                itemsPerPage: 1000000,
              }}
            />
          </div><div className="btnContainer-edit-participant">
            {this.state.signedUrl ?
              <a href={this.state.signedUrl} onClick={this.handleDownload} download><Button  size="md" color="success">
                Download Reports
              </Button></a>
              : <Button onClick={() => this.handleSubmit()} type="submit" size="md" color="primary">
                {this.state.isLoading ? <><Spinner />Please Wait...</> : 'Retrieve Reports'}
              </Button>
            }
            <Button onClick={this.props.closeModal} size="md" variant="outline-primary">
              Cancel
            </Button>
          </div>

        </Container>

      </Overlay>
    );
  }
}

const mapStateToProps = state => {
  return {
    idToken: state.auth.idToken,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    bulkSendPdf: sendPdfsObject => dispatch(actions.bulkSendPdf(sendPdfsObject)),
    closeModal: () => dispatch(actions.closeModal()),
    openToaster: value => dispatch(actions.openToaster(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkSendPdfModal);
